module.exports = __webpack_public_path__ + "static/fabric-image-default-d726435c72fbec28a61b570a978b8515.png";